import {
  API_ERROR,
  SET_PARAMS,
  AUDIT_PURCHASE_ORDER_LIST,
  AUDIT_PURCHASE_ORDER_LIST_SUCCESS,
  OPEN_SCREEN,
  AUDIT_PURCHASE_ORDER,
  AUDIT_MIN_WINDOW,
  AUDIT_MAX_WINDOW,
  AUDIT_POP_RIGHT,
  AUDIT_PURCHASE_ORDER_ROW_DATA_SUCCESS,
  AUDIT_IGP_LIST_DATA,
  AUDIT_IGP_LIST_DATA_SUCCESS,
  AUDIT_IGP_ROW_DATA,
  AUDIT_IGP_ROW_DATA_SUCCESS,
  AUDIT_QUOTATION_ROW_DATA,
  AUDIT_QUOTATION_ROW_DATA_SUCCESS,
  AUDIT_RFQ_ROW_DATA,
  AUDIT_RFQ_ROW_DATA_SUCCESS,
  AUDIT_CQ_DATA,
  AUDIT_PI_ROW_DATA,
  AUDIT_PI_ROW_DATA_SUCCESS,
  AUDIT_MR_ROW_DATA,
  AUDIT_MR_ROW_DATA_SUCCESS,
  ITEM_AUDIT_APPROVAL,
} from "./actionTypes";

export const getAuditPurchaseOrderList = (data) => {
  return {
    type: AUDIT_PURCHASE_ORDER_LIST,
    payload: { data },
  };
};
export const AuditPurchaseOrderListSuccessful = (response) => {
  return {
    type: AUDIT_PURCHASE_ORDER_LIST_SUCCESS,
    payload: response,
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const OpenScreen = (data) => {
  return {
    type: OPEN_SCREEN,
    payload: data,
  };
};
//------------------
export const AuditPO = (data) => {
  return {
    type: AUDIT_PURCHASE_ORDER,
    payload: data,
  };
};
// export const getAuditPORowData = (poId) => {
//   return {
//     type: AUDIT_PURCHASE_ORDER_ROW_DATA,
//     payload: { poId },
//   };
// };
export const AuditPORowDataSuccessful = (response) => {
  return {
    type: AUDIT_PURCHASE_ORDER_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const getAuditIGPListData = (data) => {
  return {
    type: AUDIT_IGP_LIST_DATA,
    payload: data,
  };
};
export const AuditIGPListDataSuccessful = (response) => {
  return {
    type: AUDIT_IGP_LIST_DATA_SUCCESS,
    payload: response,
  };
};
export const getAuditIGPRowData = (data) => {
  return {
    type: AUDIT_IGP_ROW_DATA,
    payload: data,
  };
};
export const AuditIGPRowDataSuccessful = (response) => {
  return {
    type: AUDIT_IGP_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const getAuditQRowData = (data) => {
  return {
    type: AUDIT_QUOTATION_ROW_DATA,
    payload: data,
  };
};
export const AuditQRowDataSuccessful = (response) => {
  return {
    type: AUDIT_QUOTATION_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const AuditPopRight = (index) => {
  return {
    type: AUDIT_POP_RIGHT,
    payload: index,
  };
};
export const getAuditRFQRowData = (data) => {
  return {
    type: AUDIT_RFQ_ROW_DATA,
    payload: data,
  };
};
export const AuditRFQRowDataSuccessful = (response) => {
  return {
    type: AUDIT_RFQ_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const getAuditCQData = (data) => {
  return {
    type: AUDIT_CQ_DATA,
    payload: data,
  };
};

export const getAuditPIRowData = (data) => {
  return {
    type: AUDIT_PI_ROW_DATA,
    payload: data,
  };
};
export const AuditPIRowDataSuccessful = (response) => {
  return {
    type: AUDIT_PI_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const getAuditMRRowData = (data) => {
  return {
    type: AUDIT_MR_ROW_DATA,
    payload: data,
  };
};
export const AuditMRRowDataSuccessful = (response) => {
  return {
    type: AUDIT_MR_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const MaximizeWindow = (index) => {
  return {
    type: AUDIT_MIN_WINDOW,
    payload: index,
  };
};
export const MinimizeWindow = (index) => {
  return {
    type: AUDIT_MAX_WINDOW,
    payload: index,
  };
};
export const itemAuditApproval = (data) => {
  return {
    type: ITEM_AUDIT_APPROVAL,
    payload: { data },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
